import { render } from "./QuantityOfTransfersPerDayChart.vue?vue&type=template&id=1d46a9bb"
import script from "./QuantityOfTransfersPerDayChart.vue?vue&type=script&lang=js"
export * from "./QuantityOfTransfersPerDayChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__